package co.maytes.standupbot.dashboard.features.onboarding

import androidx.compose.runtime.Composable
import co.maytes.standupbot.dashboard.components.layout.AuthGuard
import co.maytes.standupbot.dashboard.components.widgets.Button
import co.maytes.standupbot.dashboard.components.widgets.ButtonSize
import co.maytes.standupbot.dashboard.components.widgets.ButtonVariant
import co.maytes.standupbot.dashboard.components.widgets.icons.LucideArrowLeft
import com.varabyte.kobweb.core.rememberPageContext

@Composable
fun OnboardingShell(
    step: OnboardingStep,
    headline: String,
    subline: String? = null,
    art: (@Composable () -> Unit)? = null,
    nextEnabled: Boolean = true,
    nextLoading: Boolean = false,
    nextLabel: String = if (step == OnboardingStep.Preview) "Finish" else "Continue",
    onNext: (() -> Unit)? = null,
    skipLabel: String? = null,
    onSkip: (() -> Unit)? = null,
    content: @Composable () -> Unit,
) = AuthGuard {
    WizardStage {
        val ctx = rememberPageContext()
        val index = OnboardingStep.ordered.indexOf(step)
        val backPath = OnboardingStep.ordered.getOrNull(index - 1)?.path ?: WELCOME_PATH

        WizardFrame(
            title = headline,
            subline = subline,
            stepper = { WizardStepper(current = index) },
            art = art,
            footerStart = {
                Button(
                    label = "Back",
                    variant = ButtonVariant.Ghost,
                    leadingIcon = { LucideArrowLeft(size = 16) },
                    onClick = { ctx.router.navigateTo(backPath) },
                )
            },
            footerEnd = {
                if (skipLabel != null && onSkip != null) {
                    Button(label = skipLabel, variant = ButtonVariant.Link, size = ButtonSize.Sm, onClick = onSkip)
                }
                Button(
                    label = nextLabel,
                    variant = ButtonVariant.Primary,
                    enabled = nextEnabled && onNext != null,
                    loading = nextLoading,
                    onClick = onNext ?: {},
                )
            },
            content = content,
        )
    }
}

private const val WELCOME_PATH = "/app/onboarding/welcome"
